import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_GetCustomRolesCatalogOut, CustomRoleCatalog } from './customRoles.types';
import { mapCustomRolesCatalog } from './customRoles.mapper';


export class CustomRoleCatalogService {
  async getCustomRoles(): Promise<ApiResponse<CustomRoleCatalog[]>> {
    const response = await apiClient.get<LC_GetCustomRolesCatalogOut>(
      API_CONFIG.ENDPOINTS.CATALOG.CUSTOM_ROLES,
    );

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapCustomRolesCatalog(response.data) };
  }
}

export const customRoleCatalogService = new CustomRoleCatalogService();
